const route = {
	name: 'purchases',
	path: '/purchases',
	meta: {
		title: 'Compras',
	},
	component: () => import('@/pages/purchases/pages-purchases-list'),
	// children: [
	// 	{
	// 		name: 'debts-to-pay-history',
	// 		path: 'debts-to-pay-history',
	// 		meta: {
	// 			title: 'Historial de cuentas por pagar',
	// 		},
	// 		component: () => import('@/components/purchases/debts-to-pay-history'),
	// 	},
	// ],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/purchases.js